import Grid, { gridClasses, GridProps } from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

export const StyledImg = styled('img')({
  height: '40%',
  width: 'auto',
});

export const StyledGridItem = styled(Grid)<GridProps>({
  [`&.${gridClasses.item}`]: {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    position: 'relative',
  },
});

export const StyledGridContainer = styled(Grid)<GridProps>(({ theme }) => ({
  [`&.${gridClasses.container}`]: {
    height: '100%',
    padding: theme.spacing(0, 3),
  },
}));
